var _componentImageCropper = function() {
    if (!$().cropper) {
        console.warn('Warning - cropper.min.js is not loaded.');
        return;
    }
    
    $('.cropper').each(function() {
        var $me = $(this);
        var $image = $me.find('.cropper-image'),
            options = {
                aspectRatio: ($me.data('w')/$me.data('h')),
                preview: $me.find('.preview'),
                data: {
                    x: 0,
                    y: 0,
                    width: $me.data('w'),
                    height: $me.data('h')
                }
            };   

        // Initialize cropper with options
        $image.cropper(options);

        // Toolbar
        $me.find('.cropper-toolbar').on('click', '[data-method]', function () {
            var $this = $(this),
                data = $this.data(),
                $target,
                result;

            if ($image.data('cropper') && data.method) {
                data = $.extend({}, data);

                if (typeof data.target !== 'undefined') {
                    $target = $(data.target);

                    if (typeof data.option === 'undefined') {
                        data.option = JSON.parse($target.val());
                    }
                }
                
                result = $image.cropper(data.method, data.option, data.secondOption);
                switch (data.method) {
                    case 'scaleX':
                    case 'scaleY':
                        $(this).data('option', -data.option);
                    break;

                    case 'getCroppedCanvas':
                        if (result) { // zapisz wynik
                            $me.find('form input[name=image]').val(result.toDataURL());
                            $me.find('form').submit();
                            
                            $($me.parents('.modal')).modal('hide');
                        }
                    break;
                }
            }
        });
        
        // znak wodny
        $me.find('.image-cropper-watermark-id').on('change', function () {
            $me.find('form input[name=watermark_id]').val($(this).val());
        });
        
        // znak wodny - pozycja
        $me.find('.image-cropper-watermark-position').on('change', function () {
            $me.find('form input[name=watermark_position]').val($(this).val());
        });
        
        // przycisk zacznij od nowa
        $me.find('.cropper-reset').on('click', function () {
            $image.cropper('destroy');
            $image.cropper(options);
        });
        
        $('.js-cropper-modal').each(function() {
           var $modal = $($(this).data('target'));
           
           $modal.on('shown.bs.modal', function (e) {
               $me.find('.cropper-reset').trigger('click');
            });
        });
    });
};

function init() {
    _componentImageCropper();
}

export const ImageCropper = {
    init
}